import type {
  GeneralsBoardFrame,
  GeneralsReplay,
  Tile,
} from "./generals-board-model";
import { boardTile } from "./generals-board-grid";

export function applyReplayFrame({
  tiles,
  frame,
}: {
  readonly tiles: readonly Tile[];
  readonly frame: readonly number[];
}): void {
  for (let offset = 0; offset < frame.length; offset += 3) {
    const index = frame[offset];
    const owner = frame[offset + 1];
    const count = frame[offset + 2];

    if (
      index === undefined ||
      count === undefined ||
      (owner !== -1 && owner !== 0 && owner !== 1)
    ) {
      throw new TypeError(
        "Replay changes require index, owner, and count triples",
      );
    }

    const tile = boardTile({ tiles, index });
    tile.owner = owner;
    tile.count = count;
  }
}
export function replayBoard({
  replay,
  startAt,
}: {
  readonly replay: GeneralsReplay;
  readonly startAt: number;
}): GeneralsBoardFrame {
  const tiles = replay.first.o.map((owner, index): Tile => {
    const count = replay.first.a[index];

    if (count === undefined)
      throw new TypeError(
        "Replay owners and armies must have matching lengths",
      );

    return { owner, count, mountain: false, general: false, castle: false };
  });

  for (const index of replay.mountains)
    boardTile({ tiles, index }).mountain = true;

  for (const [index] of replay.cities)
    boardTile({ tiles, index }).castle = true;

  for (const index of replay.generals)
    boardTile({ tiles, index }).general = true;

  // Advance silently because a game first appears mid-match.
  for (const frame of replay.frames.slice(0, startAt))
    applyReplayFrame({ tiles, frame });

  return { rows: replay.rows, cols: replay.cols, tiles };
}
